(function(Slider) {
    'use strict';

    // Rebuild of the image slider with a left and right image.

    // Variable to check if it is a slider with left and right images.
    Slider.rotate = false;

    // The elements of the slider.
    Slider.elements = {
        slider: '#slider',
        slides: '.slider_items',
        slide: '.slider_item',
        leftSlide: 'item_left',
        rightSlide: 'item_right'
    };

    // Interval for the slider, time between the slides in ms.
    Slider.interval = 5000;

    // Delay for the right slide in ms.
    Slider.delay = 2500;

    // The slide opacities.
    Slider.style = {
        hidden: {
            opacity: 0.0
        },
        visible: {
            opacity: 1.0
        }
    };

    // Loop the slider elements, build the slider, and start the slider if it is an image rotation slider.
    Slider.init = function() {
        $.each(
            $(Slider.elements.slides).children(),
            Slider.build.init
        );

        if (Slider.rotate == true) {
            Slider.start();
        }
    };

    // Build the Slider.
    Slider.build = {
        // Build the slider base.
        init: function() {
            var html = '';
            var image;
            var side;

            if ($(this).hasClass(Slider.elements.leftSlide)) {
                side = 'left';
            }

            if ($(this).hasClass(Slider.elements.rightSlide)) {
                side = 'right';
            }

            if (side) {
                image = $(this).html();

                if ($(this).data('slide') !== '') {
                    image = $(this).data('slide');
                    html = $(this).html();
                }

                if (image != '') {
                    Slider.build.slide(side, image, html);
                }
            } else {
                image = $(this).html();

                $(Slider.elements.slider).append(
                    '<div class="' + Slider.elements.slide + ' fleft" ' +
                    'style="width: 50%;height: 100%;background-image: url(\'' + image + '\');"></div>'
                );
            }
        },

        /**
         * Build a slide part.
         *
         * @param  string side
         * @param  string image
         * @param  string html
         */
        slide: function(side, image, html) {
            if ($(Slider.elements.slider + ' .' + side + '_slider').length == 0) {
                $(Slider.elements.slider).append(
                    '<div class="' + side + '_slider fleft" style="width: 50%;height: 100%;"></div>'
                );
            }

            $(Slider.elements.slider + ' .' + side + '_slider').append(
                '<div class="' + Slider.elements.slide + '" ' +
                'style="height: 100%;background-image: url(\'' + image + '\');">' +
                html +
                '</div>'
            );

            Slider.rotate = true;
        }
    };

    // Start the image slider.
    Slider.start = function() {
        $(Slider.elements.slider + ' .left_slider div:first-child').addClass('active');
        $(Slider.elements.slider + ' .right_slider div:first-child').addClass('active');

        if ($('.' + Slider.elements.rightSlide).length > 1) {
            setTimeout(function() {
                setInterval(Slider.go, Slider.interval, 'right');
            }, Slider.delay);
        }

        if ($('.' + Slider.elements.leftSlide).length > 1) {
            setInterval(Slider.go, Slider.interval, 'left');
        }
    };

    /**
     * Set the next slide.
     *
     * @param string side
     */
    Slider.go = function(side) {
        var active = $(Slider.elements.slider + ' .' + side + '_slider div.active');
        var next;

        if (active.length == 0) {
            active = $(Slider.elements.slider + ' .' + side + '_slider div:last');
        }

        next = $(Slider.elements.slider + ' .' + side + '_slider div:first');
        if (active.next().length) {
            next = active.next();
        }

        active.addClass('last-active');

        next.css(Slider.style.hidden)
            .addClass('active')
            .animate(Slider.style.visible, 1000, function() {
                active.removeClass('active last-active');
            });
    };

    // Create the handler.
    Way2web.handlers.slider = Slider.init;
})(window.Way2web.Slider = window.Way2web.Slider || {});
